import React from 'react';

import {Tag} from 'folder-items/FileConstants';
import {ServerRequestTask, UIRequestTask, isRequestTaskGraphQL} from 'requests/tasks/RequestTaskConstants';
import SchemaTagInputs from 'schemas/tags/SchemaTagInputs';
import * as TagUtil from 'schemas/tags/TagUtil';
import CollapsibleCard from 'ui-library/CollapsibleCard';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {LABEL_STYLES} from 'ui-library/inputs/InputConstants';

import {RequestTaskGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTaskGraphQL';
import {RequestTaskSchemaGraphQL} from '../../../graphql-fragments/requests/schemas/__generated/RequestTaskSchemaGraphQL';

interface BaseRequestTaskCardProps {
  initiallyExpanded?: boolean;
  isWritable: boolean;
  requestTaskSchema: RequestTaskSchemaGraphQL;
  onRemove: () => void;
}

type MaybeCreatingProps =
  | {
      isCreating: true;
      requestTask: UIRequestTask;
      onUpdate: (requestTask: UIRequestTask) => void;
    }
  | {isCreating: false; requestTask: RequestTaskGraphQL; onUpdate: (requestTask: ServerRequestTask) => void};

function getRequestTaskTags(requestTask: RequestTaskGraphQL | UIRequestTask): Array<Tag> {
  return isRequestTaskGraphQL(requestTask) ? requestTask.tagsJson : requestTask.tags;
}

export default function RequestTaskCard({
  initiallyExpanded = true,
  isWritable,
  requestTaskSchema,
  onRemove,
  isCreating,
  requestTask,
  onUpdate,
}: BaseRequestTaskCardProps & MaybeCreatingProps): JSX.Element {
  return (
    <CollapsibleCard
      leftHeader={requestTaskSchema ? requestTaskSchema.name : 'Task'}
      initiallyExpanded={initiallyExpanded}
      rightHeader={
        isWritable && (
          <a
            className="faded u-danger-pointer"
            onClick={(e) => {
              // Prevent card from collapsing/expanding
              e.stopPropagation();
              onRemove();
            }}
          >
            <BenchlingIcon icon="delete" />
          </a>
        )
      }
    >
      <SchemaTagInputs
        itemLinkAllowed={true}
        isCreating={isCreating}
        isWritable={isWritable}
        labelStyle={LABEL_STYLES.SUBLABEL}
        onUpdateTags={(tags: Array<Tag>) => {
          if (isCreating) {
            onUpdate({
              ...requestTask,
              tags,
            });
          } else {
            onUpdate({
              ...requestTask,
              schemaId: requestTask.schema.id,
              requestId: requestTask.request.id,
              tags: TagUtil.getTagsToSet(tags),
            });
          }
        }}
        tags={getRequestTaskTags(requestTask)}
      />
    </CollapsibleCard>
  );
}
